import * as t from 'io-ts';

import type { SelectClearableDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface HierarchyVariantIdSettingDefinition extends SelectClearableDefinition {
    key: 'HIERARCHY_VARIANT_ID';
    options: Array<{ key: string; label: string }>;
}

const definition: HierarchyVariantIdSettingDefinition = {
    key: 'HIERARCHY_VARIANT_ID',
    type: 'SelectClearable',
    label: 'Hierarchy variant id',
    value: null,
    options: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.union([t.string, t.null]));

export const codec = specSettingsInterface.input;

export const HierarchyVariantIdSettingDefinition = define({
    key: 'HIERARCHY_VARIANT_ID',
    label: 'hierarchyVariantId',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.hierarchyVariantId),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.hierarchyVariantId),
});
